import React from 'react';
import { Section, Container, Typography, Anchor, Button, Card } from 'components/base';

import { Head } from '../components/layout';

const MaintenancePage = () => {
  return (
    <>
      <Head title="Maintenance" />

      <Section>
        <Container className="text-center">
          <Anchor href="/" className="logo">
            <img src="/static/img/logo-mycanvas.svg" alt="MyCanvas" />
          </Anchor>
        </Container>
      </Section>

      <Section type="blue">
        <Container className="text-center p-5">
          <Typography.H2 className="section-title mb-2">
            Sorry, we’re down for scheduled maintenance
          </Typography.H2>
          <Typography.H4>
            We’re working to update the website. Try to refresh the page in a while.
          </Typography.H4>
          <Button type="primary" className="mt-5" onClick={() => window.location.reload()}>
            Refresh Now
          </Button>
        </Container>
      </Section>

      <Section className="text-center">
        <Container className="p-5">
          <Typography.H3 className="mb-2">Want to talk to us about this maintenance?</Typography.H3>
          <Typography.P>
            <a href="mailto:help@mycanvas.com" className="text-link">
              help@mycanvas.com
            </a>{' '}
            &nbsp;{' '}
            <a
              href="https://intercom.help/mycanvas/en/"
              target="_blank"
              rel="noreferrer"
              className="text-link"
            >
              Check out our FAQ
            </a>
          </Typography.P>
        </Container>
      </Section>
    </>
  );
};

export default MaintenancePage;
